let env
if (location.host.indexOf('h5.cbre.thinkinpower') > -1 || location.host.indexOf('h5.cbreip.com') > -1 || location.host.indexOf('h5.x.cbreip.com') > -1) {
  env = 'production'
} else if (location.host.indexOf('h5.p.cbreip.com') > -1) {
  env = 'release'
} else {
  env = 'test'
}

let config = {
  env: env
}

export default config



// WEBPACK FOOTER //
// ./src/config/index.js